import getSearchQueryPartAtPosition from './getSearchQueryPartAtPosition'

// Ammend a query string with another at a specified position
export default function amendSearchQueryString(
  baseQueryString,
  amendString,
  position = baseQueryString.length - 1,
  commit = true
) {
  // const trimmedBase = baseQueryString.trim()
  const currentPart = getSearchQueryPartAtPosition(
    baseQueryString,
    position,
    commit
  )
  const { after = '', before = '' } = currentPart || {}
  const finalSpace = !amendString.match(/:$/) && commit ? ' ' : ''
  return `${before}${before && ' '}${amendString}${finalSpace}${after &&
    ' '}${after}`
}
